$(document).ready(function(){
  $(".header").mouseover(function() {
    jQuery('.transparentPage ').addClass('nonTransparent');
  });
  $(".header").mouseout(function() {
   jQuery('.transparentPage ').removeClass('nonTransparent');
  });

  // Images with text slider and Images with text slider full
  $(".image-with-text-slider").each(function() {
    let sliderFor = $(this).find('.slider-for');
    let sliderNav  = $(this).find('.slider-nav');
    
    var sliderfor = sliderFor.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      asNavFor: sliderNav
    });
    
    var slidernav = sliderNav.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: sliderFor,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: false,
      dots: true,
      arrows: false,
      appendDots: $(this).find(".custom-slick-dots")
    });
  });
  
  $(".image-with-text-slider-full").each(function() {
    let sliderWrap = $(this).find('.image-text-slider-full');
    deskMobSlider(sliderWrap, 1 , 1, true, 3000, false, true, false, false, true, $(this));
  });
  
  
  
  $(".image-with-product-slider").each(function() {
    let sliderWrap = $(this).find('.image-product-slider');
    deskMobSlider(sliderWrap, 1 , 1, true, 3000, false, true, false, false, true, $(this));
  });
  
  $(".image-with-products-slider").each(function() {
    let sliderWrap = $(this).find('.image-products-slider');
    deskMobSlider(sliderWrap, 1 , 1, true, 3000, false, true, false, false, true, $(this));
  });

  $(".image-with-video-slider").each(function() {
    let sliderWrap = $(this).find('.image-video-slider');
    deskMobSlider(sliderWrap, 1 , 1, true, 3000, false, true, false, false, true, $(this));
  });

  $(".banner-slider").each(function() {
    let sliderWrap = $(this).find('.banner-slider-wrapper');
    deskMobSlider(sliderWrap, 1 , 1, true, 3000, false, true, false, false, true, $(this));
  });

  $(".image-timer-wrapper").each(function() {
    let sliderWrap = $(this).find('.image-timer');
    deskMobSlider(sliderWrap, 1 , 1, true, 3000, false, true, false, false, true, $(this));
  });

  $(".image-with-video-img-slider").each(function() {
    let sliderWrap = $(this).find('.image-video-img-slider');
    deskMobSlider(sliderWrap, 1 , 1, true, 3000, false, true, false, false, true, $(this));
  });
  
  $(".single-image-with-products-slider").each(function() {
    let sliderWrap = $(this).find('.slider-nav');
    deskMobSlider(sliderWrap, 1 , 1, true, 3000, false, true, false, false, true, $(this));
  });

  (function($) {
      $.fn.clickToggle = function(func1, func2) {
          let funcs = [func1, func2];
          this.data('toggleclicked', 0);
          this.click(function() {
              let data = $(this).data();
              let tc = data.toggleclicked;
              $.proxy(funcs[tc], this)();
              data.toggleclicked = (tc + 1) % 2;
          });
          return this;
      };
  }(jQuery));

  $(document).on('click', '.cont-read', function(e) {
    e.preventDefault();
    $(this).prev().toggleClass('cont-content-collapse');

    let height = $(this).parents('div[tabindex="0"]').outerHeight(true);
    $(this).parents(".slick-list.draggable").height(height);
    if ($(this).text().indexOf('More') != -1) {
      $(this).text('Read Less');
    } else {
      $(this).text('Read More');
    }
  });
  // Images with text slider and Images with text slider full ends

  // Video Section
  $('.custom-video, .play-button-wrapper').click(function () {
    if($(this).parent().children(".custom-video").get(0).paused) {
      $(this).parent().children(".custom-video").get(0).play();
      $(this).parent().children(".play-button-wrapper").fadeOut();
    } else {
      $(this).parent().children(".custom-video").get(0).pause();
      $(this).parent().children(".play-button-wrapper").fadeIn();
    }
  });
  // Video Section Ends

  // Featured Collection with swatches mobile only slider
  $(".collection--swatches").each(function() {
    let sliderWrap = $(this).find('.collections__items.mob-only');
    if(sliderWrap.hasClass('centermode-mob')) {
      mobileOnlySlider(sliderWrap, 1, 1, true, false, true, '80px', 900);
    } else {
      mobileOnlySlider(sliderWrap, 2, 1, false, true, false, null, 900);
    }
  });
  // Featured Collection with swatches mobile only slider ends

  // Image Blocks mobile only slider
  $(".image-blocks.mob-only").each(function() {
    let sliderWrap = $(this).find('.section-blocks-wrapper');
    mobileOnlySlider(sliderWrap, 1, 1, false, false, true, '25%', 900);
  });
  // Image Blocks mobile only slider ends

  // Featured Collection with swatches full slider
  $(".collection--swatches").each(function() {
    let sliderWrap = $(this).find('.collections__items.desk-mob-only');
    let sliderWrapper = sliderWrap.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      pauseOnHover: false,
      arrows: true,
      dots: false,
      fade: false,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '80px'
          }
        }
      ]
    });
  });
  // Featured Collection with swatches full slider ends

  // Timer Block
  $('.timer').each(function() {
    let endDate = $(this).data('end-date');
    let daySpan = $(this).find('.js-timer-days'),
        hourSpan = $(this).find('.js-timer-hours'),
        minSpan = $(this).find('.js-timer-minutes'),
        secSpan = $(this).find('.js-timer-seconds');
    let second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;
    let countDown = new Date(endDate).getTime(),
        x = setInterval(function() {
        let now = new Date().getTime(),
            distance = countDown - now;
        if(distance >= 0) {
          daySpan.text(Math.floor(distance / (day)).toLocaleString('en-AU', {minimumIntegerDigits: 2})),
          hourSpan.text(Math.floor((distance % (day)) / (hour)).toLocaleString('en-AU', {minimumIntegerDigits: 2})),
          minSpan.text(Math.floor((distance % (hour)) / (minute)).toLocaleString('en-AU', {minimumIntegerDigits: 2})),
          secSpan.text(Math.floor((distance % (minute)) / second).toLocaleString('en-AU', {minimumIntegerDigits: 2}));
        }
      }, second);
  });
  // Timer Block Ends

  // Play and Pause Slider
  $('.playPause').clickToggle(function() {
    $(this).parent().siblings('.slick-slider').slick('slickPause');
    $(this).html('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_2" x="0px" y="0px" width="15px" height="15px" viewBox="0 0 408.221 408.221" style="enable-background:new 0 0 408.221 408.221;" xml:space="preserve"><g><g><path d="M204.11,0C91.388,0,0,91.388,0,204.111c0,112.725,91.388,204.11,204.11,204.11c112.729,0,204.11-91.385,204.11-204.11    C408.221,91.388,316.839,0,204.11,0z M286.547,229.971l-126.368,72.471c-17.003,9.75-30.781,1.763-30.781-17.834V140.012    c0-19.602,13.777-27.575,30.781-17.827l126.368,72.466C303.551,204.403,303.551,220.217,286.547,229.971z"/></g></g></svg>');
  }, function() {
      $(this).parent().siblings('.slick-slider').slick('slickPlay');
      $(this).html('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="15px" height="15px" x="0px" y="0px" viewBox="0 0 310.284 310.284" style="enable-background:new 0 0 310.284 310.284;" xml:space="preserve"><path d="M155.142,0C69.597,0,0,69.597,0,155.142s69.597,155.142,155.142,155.142s155.142-69.597,155.142-155.142  S240.688,0,155.142,0z M130.392,212.864c0,9.665-7.835,17.5-17.5,17.5s-17.5-7.835-17.5-17.5v-115c0-9.665,7.835-17.5,17.5-17.5  s17.5,7.835,17.5,17.5V212.864z M209.392,212.864c0,9.665-7.835,17.5-17.5,17.5s-17.5-7.835-17.5-17.5v-115  c0-9.665,7.835-17.5,17.5-17.5s17.5,7.835,17.5,17.5V212.864z"/></svg>');
  });
  // Play and Pause Slider Ends

  // Desktop and Mobile Slider
  function deskMobSlider($slidername,
                         $slidesToShow,
                         $slidesToScroll,
                         $autoplay,
                         $autoplaySpeed,
                         $pauseOnHover,
                         $dots,
                         $arrows,
                         $fade,
                         $infinite,
                         $this) {
    let slider = $($slidername);
    let settings = {
      slidesToShow: $slidesToShow,
      slidesToScroll: $slidesToScroll,
      autoplay: $autoplay,
      autoplaySpeed: $autoplaySpeed,
      pauseOnHover: $pauseOnHover,
      dots: $dots,
      arrows: $arrows,
      fade: $fade,
      infinite: $infinite,
      appendDots: $this ? $this.find(".custom-slick-dots") : null,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: true
          }
        }
      ]
    };
  
    slider.slick(settings);
  
    $(window).on("resize", function () {
      if (!slider.hasClass("slick-initialized")) {
        return slider.slick(settings);
      }
    });
  } 
  // Desktop and Mobile Slider Ends

 // BANNER WITH LINKS CLICK SCROLL
  
  $(".banner-links a").click(function() {
    $('html, body').animate({
        scrollTop: $($(this).data('scroll-id')).offset().top - 100
    }, 500);
  });
 // BANNER WITH LINKS CLICK SCROLL END 

  // Mobile Only Slider
  function mobileOnlySlider($slidername, $slidesToShow, $slidesToScroll, $dots, $arrows, $centermode, $centerpadding, $breakpoint) {
    let slider = $($slidername);
    let settings = {
      mobileFirst: true,
      slidesToShow: $slidesToShow,
      slidesToScroll: $slidesToScroll,
      dots: $dots,
      arrows: $arrows,
      centerMode: $centermode,
      centerPadding: $centerpadding,
      responsive: [
        {
          breakpoint: $breakpoint,
          settings: "unslick"
        }
      ]
    };
  
    slider.slick(settings);
  
    $(window).on("resize", function () {
      if ($(window).width() > $breakpoint) {
        return;
      }
      if (!slider.hasClass("slick-initialized")) {
        return slider.slick(settings);
      }
    });
  } 
  // Mobile Only Slider Ends
  
  // Collection Template
  // Collection filter
  $(document).on('click', '.filter-title-wrap', function() {
    $(this).toggleClass('open');
    $(this).parent().next().toggle();

    if($(this).hasClass('open')) {
      $('body').css('overflow-y', 'hidden');
      $( ".bodyBlur" ).show();
    } else {
      $('body').css('overflow-y', 'auto');
      $( ".bodyBlur" ).hide();
    }
  });

  $(document).on('click', '#CollectionFilterForm .filter-group__heading__text', function(e) {
    e.preventDefault();
    if($(window).width() < 900) {
      $(this).parent().siblings().removeClass('open').find('.filter-group__items').hide();
      $(this).parent().toggleClass('open');
      $(this).next().toggle();
    }
  });

  $(document).on('click', '.mob-layout .mob-layout__two-col', function() {
    $('#CollectionProductGrid .collections__items').addClass('two-cols');
    $('#CollectionProductGrid .collections__item').each(function() {
      $(this).find('.prdct-img-slider').slick('unslick');
      deskMobSlider($(this).find('.prdct-img-slider'), 1 , 1, false, null, false, false, false, false, true, null);
    });
  });

  $(document).on('click', '.mob-layout .mob-layout__single-col', function() {
    $('#CollectionProductGrid .collections__items').removeClass('two-cols');
    $('#CollectionProductGrid .collections__item').each(function() {
      $(this).find('.prdct-img-slider').slick('unslick');
      deskMobSlider($(this).find('.prdct-img-slider'), 1 , 1, false, null, false, false, false, false, true, null);
    });
  });
  // Collection filter ends
  
  // Second Image on hover
  $(document).on('mouseenter touchstart', '#CollectionProductGrid .collections__item', function() {
      let hoverTrueImg = $(this).find('.hover-true-img');
    if(hoverTrueImg.length) {
      let hoverImg = $(this).find('img.hover-img');
      $(this).parents('.collections__items').find('.hover-true-img').not(hoverTrueImg).show();
      $(this).parents('.collections__items').find('img.hover-img').not(hoverImg).hide();
      $(this).parents('.collections__items').find('.hover-info').css('cssText', 'opacity:0;visibility:hidden;');
      $(this).find('.hover-info').css('cssText', 'opacity:1;visibility:visible;');
      hoverImg.show();
    }
  }).on('mouseleave', '#CollectionProductGrid .collections__item', function() {
    if($(this).find('.hover-true-img').length) {
      $(this).find('img.hover-img').hide();
      $(this).find('.hover-info').css('cssText', 'opacity:0;visibility:hidden;');
    }
  });
  // Second Image on hover ends

  // Second Image on hover  on slider  by ARJUN
  if(screen.width >1024){
    $(document).on('mouseenter touchstart', '#CollectionProductGrid .collections__item', function() {
        let hoverTrueImg = $(this).find('.prdct-img-slider');
      if(hoverTrueImg.length) {
        let hoverImg = $(this).find('img.hover-img');
        $(this).parents('.collections__items').find('.prdct-img-slider').not(hoverTrueImg).show();
        $(this).parents('.collections__items').find('img.hover-img').not(hoverImg).hide();
        $(this).parents('.collections__items').find('.hover-info').css('cssText', 'opacity:0;visibility:hidden;');
        $(this).find('.hover-info').css('cssText', 'opacity:1;visibility:visible;');
        hoverImg.show();
      }
    }).on('mouseleave', '#CollectionProductGrid .collections__item', function() {
      if($(this).find('.prdct-img-slider').length) {
        $(this).find('img.hover-img').hide();
        $(this).find('.hover-info').css('cssText', 'opacity:0;visibility:hidden;');
      }
    });
  }
  // Second Image on hover on slider by ARJUN // END
  
  // Product images slider
  $(".collections__item").each(function() {
    let sliderWrap = $(this).find('.prdct-img-slider')
    deskMobSlider(sliderWrap, 1 , 1, false, null, false, false, true, false, true, $(this));
  });
  // Product images slider ends
  
  // Ajaxinate collection
  function ajaxinateCallback() {
    $(".collections__item .prdct-img-slider").not('.slick-slider').each(function() {
      let sliderWrap = $(this);
      deskMobSlider(sliderWrap, 1 , 1, false, null, false, false, false, false, true, $(this));
    });

    let item = $('.collections__item');
    loadSwatches(item);

    $('.collections__item').bind('mouseenter', function() {
      if (typeof $(this).data('video') !== 'undefined') {
        if ($(this).find('video').length) 
          return;
        const source = $(this).attr('data-video');
        $(this).find('.collections__item-image-wrap').append(`<video src="${source}" autoplay muted playsinline loop></video>`);
      }
    });
  }
  if ( $('#AjaxinateLoop').length > 0 ) {
    var endlessScroll = new Ajaxinate({
      container: '#AjaxinateLoop',
      pagination: '#AjaxinatePagination',
      loadingText: '<img src="//cdn.shopify.com/s/files/1/0158/6718/3158/t/2/assets/loading.png?9285" alt="Ena Pelly - Next"><span>E — P</span>',
      callback: ajaxinateCallback
    });
  }
  //Ajaxinate collection ends

  // Color swatch click functionality
  $(document).on('click', 'label.swatch-color', function() {
    if(!$(this).prev().is(':checked')) {
      let productHandle = $(this).data('product-handle'),
          productTitle = $(this).parents('.collections__item').find('.prdct-info h4'),
          sliderWrapper = $(this).parents('.collections__item').find('.prdct-img-slider'),
          mainImg = $(this).parents('.collections__item').find('.collections__item-image-wrap img:first-of-type').not('.hover-img'),
          hoverImg = $(this).parents('.collections__item').find('.hover-img'),
          sizeWrapper = $(this).parents('.collections__item').find('.size-list'),
          imageLinkWrap = $(this).parents('.collections__item').find('.collections__item-image-wrap'),
          sliderItems = '',
          sizeOptions = '<span class="size-optn-ttl">SIZE</span>',
          mainImgNew = '',
          hoverImgNew = '',
          hoverClass = '';

      if($(this).parents('.collections__item').find('.hover-true-img').length) {
        hoverClass = 'hover-true-img'; 
      }
      
      jQuery.getJSON(window.Shopify.routes.root + 'products/' + productHandle + '.js', function(product) { 
        
        productTitle.find('a').attr('data-title', product.title);
        imageLinkWrap.attr('href', product.url);
        $.each(product.images, function(index, image) {
          sliderItems += `<img class="lazyload ${hoverClass}"
                            alt="${product.title}"
                            src="${image.replace('.jpg', '_50x.jpg').replace('.jpeg', '_50x.jpeg').replace('.png', '_50x.png')}"
                            data-src="${image.replace('.jpg', '_{width}x.jpg').replace('.jpeg', '_{width}x.jpeg').replace('.png', '_{width}x.png')}"
                            data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048, 2450, 2700, 3000, 3350, 3750, 4100]"
                            data-parent-fit="cover"
                            data-sizes="auto"
                          >`;
          if(index == 0) {
            mainImgNew += image;
          } else if (index == 1) {
            mainImgNew += image;
            hoverImgNew += image;
          }
        });

        $.each(product.variants, function(index, variant) {
          let disabledClass = '',
              disabledAttr = '',
              sizeValue = '';
          if(!variant.available) {
            disabledClass += 'sizeDisabled';
            disabledAttr += 'disabled';
          }
          $.each(product.options, function(index, option) {
            if(option.name == 'Size' || option.name == 'size') {
              $.each(option.values, function(index, value) {
                if(value == variant.option1 || value == variant.option2 || value == variant.option3) {
                    sizeValue += value;
                }
              });
            }
          });
          sizeOptions += `<div class="size-optn-wrap">
                            <input
                              type="radio"
                              name="size_${variant.id}"
                              id="size_${variant.id}-${index+1}"
                              class="size_${variant.id}"
                              ${disabledAttr}
                            >
                            <label
                              for="size_${variant.id}-${index+1}"
                              class="size-optn ${disabledClass}"
                              data-value="${sizeValue}" 
                              data-var="${variant.id}"
                            >
                              ${sizeValue}
                            </label>
                          </div>`;
        });

        if(sliderWrapper.length) {
          sliderWrapper.slick('unslick');
          sliderWrapper.html(sliderItems);
          deskMobSlider(sliderWrapper, 1 , 1, false, null, false, false, false, false, true, null);
        }

        if(mainImg.length) {
          if(typeof hoverImg.attr('data-src') !== 'undefined' && hoverImg.attr('data-src') !== false) {
            hoverImg.removeAttr('data-src');
          }
          hoverImg.attr('src', hoverImgNew).removeAttr('data-srcset').removeAttr('srcset');
          mainImg.attr('src', mainImgNew).removeAttr('data-srcset').removeAttr('srcset');
        }

        if(sizeWrapper.length) {
          sizeWrapper.html(sizeOptions);
        }
      });
    }
  });
  // Color swatch click functionality ends
  
  //Add to cart functionality on size click
  $(document).on('click', '.template-collection label.size-optn, .template-search label.size-optn', function() {
    let varId = $(this).data('var');
    if( $(this).hasClass('sizeDisabled') ){ }
    else{ CartJS.addItem(varId); }
       
  });
  //Add to cart functionality on size click ends

  // Color swatches
  if($('#AjaxinateLoop').length) {
    let item = $(this).find($('.collections__item'));
    console.log(item);
    loadSwatches(item);
  }
  function loadSwatches(item) {
	fetch('https://enapelly.com.au/collections/all?view=all-products')
    .then(response => {
      return response.json();
    })
    .then(data => {
      let bgImages = `sea green check: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/sea_green_check.jpg?v=1668394534,houndstooth: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/houndstooth.jpg?v=1668394534,green houndstooth: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/green_houndstooth.jpg?v=1668394536,tan stripe: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/tan_stripe.jpg?v=1668394534,black pinstripe: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/black_pinstripe.jpg?v=1668395319,snake: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/snake.jpg?v=1668394534,white pinstripe: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/white_pinstripe.jpg?v=1668394534,fig check: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/fig_check.jpg?v=1668394535,stone snow leopard: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/stone_snow_leopard.jpg?v=1668394534,blue / bright white: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/blue-brightwhite.jpg?v=1670450768,cranberry / bright white: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/cranberry-brightwhite.jpg?v=1670450768,black/silver: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/Black-silver.jpg?v=1670450768, bone/ stone check:https://cdn.shopify.com/s/files/1/0023/1047/1743/files/bone--stone-check.jpg?v=1676501929, ena print:https://cdn.shopify.com/s/files/1/0023/1047/1743/files/Ecom-Image-Size.jpg?v=1676501929, ginger check: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/cfghvjb.jpg?v=1676501929,ena print black: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/vbh.jpg?v=1676501929,turtle dove check: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/dxgfchvj.jpg?v=1676501929,black/ iguana: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/Black-iguana.jpg?v=1676501929,bone/ stone: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/bone-stone.jpg?v=1676501929,black/ grey: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/black-grey.jpg?v=1676501929,spiced coral check: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/spiced-coral-check.jpg?v=1690949262,vintage white/ orchid: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/vintage-white-orchid.jpg?v=1690949262,mini check: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/mini-check.jpg?v=1690949263,sunset stripe: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/sunset-stripe.jpg?v=1690950896,black speckle: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/black-speckle.jpg?v=1690950897,black croc texture: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/black-croc-texture.jpg?v=1690950897,sage/ magnet/ bone: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/sage_magnet_bone.jpg?v=1690951876,magnet/ cobalt: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/magnet_cobalt.jpg?v=1690951876,worn black: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/worn-black.jpg?v=1690952905,ginger check: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/ginger-check.jpg?v=1690952905,ena print: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/ena-print.jpg?v=1690952905,bone/ black: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/bone_black.jpg?v=1690955222,red brick print: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/red-brick-print.jpg?v=1690955222,red brick pinstripe: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/red-brick-pinstripe.jpg?v=1690955222,grey pin stripe: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/grey-pin-stipe.jpg?v=1690955222,spotted leopard: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/spotted-leopard.jpg?v=1690955222,meadow violet marle: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/meadow-violet-marle.jpg?v=1690955222,meadow violet tweed: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/meadow-violet-tweed.jpg?v=1690955222,dark authentic rigid: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/dark-authentic-rigid.jpg?v=1692321680,washed black rigid: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/washed-black-rigid.jpg?v=1692321784,light authentic rigid: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/light-authentic-rigid.jpg?v=1692321728,mid authentic rigid: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/mid-authentic-rigid.jpg?v=1692321702,soft white: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/soft-white.jpg?v=1692321746,white/ stone: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/white--stone-swatch.jpg?v=1693187620,white/ black fleck: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/white--black-fleck.jpg?v=1693187973,multi: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/KLFTEE-MULTI.jpg?v=1714349355,summer blue: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/summer-blue.jpg?v=1693187967,warped print: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/warped-print.jpg?v=1698121303,ice blue stripe: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/ice-blue-stripe.jpg?v=1701132489,Iris swirl: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/iris-swirl.jpg?v=1715217723,biscuit check: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/biscuit-check.jpg?v=1715217724,bone-mushroom: https://cdn.shopify.com/s/files/1/0023/1047/1743/files/Bone-Mushroom-Swatch.jpg?v=1717383993`,
          bgImagesArr = bgImages.split(','),
          colorCodes = `evergreen:#06c282,black:#000000,vintage black:#26262a,vintage white:#ebece9,washed evergreen:#02bb7f,taupe:#d5c4bc,mid blue wash:#bfced7,washed black:#211c20,charcoal wash:#726b6d,charcoal:#59504f,white marle:#edeef7,azure blue:#52b2e6,grey marle:#8d8d91,firecracker:#fa7d3f,bone:#efeade,bright white:#faf7f8,caramel:#8e5637,duck egg:#c4d0cc,ivory:#ebdfd6,x<br />turtle dove textured:#e0d8d0,cherry:#e3203b,fig:#533838,carnation:#ff86ab,powder pink:#fdd8d7,alabaster:#e6ded5,smoke green:#a7a78c,almond:#caa184,smoke green wash:#c5c1a3,stone:#bdaaa1,white:#f1f1ef,ink navy:#223b57,oatmeal:#ead9d1,sand:#eedbc8,camel:#eac8af,teddy:#d8a992,cherry:#f83f50,patent black:#171717,blue breeze:#7db0df,washed blue breeze:#438cc1,vintage white boucle:#ebece9,butter:#f0e2c5,washed coral:#ff8882,coral:#f55a6a,black/black:#171717,black/almond:#171717,black/bone:#171717,navy:#34324a,washed lollipop:#f45654,washed brilliant blue:#0088d6,light blue indigo:#a1c2d6,ginger:#ccab91,washed dark navy:#464c68,washed iguana:#8f8f53,nile:#a4ab71,washed burnt orange:#ee5547,red orange:#f9744f,turtle dove:#e4d7c7,washed ensign blue:#223457,ensign blue:#0a2f4d,seal brown:#6c4b42,apricot:#e5cb9b,hunter green:#7f7a5c,birch:#dad1b8,tobacco:#673b19,almond buff:#efd9ca,black/ white stitch:#1a1b1d,nile/ white marle:#edeef7,seal brown/ white alyssum:#38251f,mandarin orange:#E4895B,cognac:#A7785D,marigold:#fbc952,pastel lilac:#a999bf,retro purple:#afa0ca,cherry red:#d0433d,mid grey marle:#dbdde1,mid grey:#b5b9bc,whiskey:#8f503c,orchid:#be8798,sandshell:#dcd7cb,cobalt blue:#047adb,magnet:#514d55,sage:#c7c6ac,meadow violet:#8e65ad,mellow blue:#77befd,azure blue:#016fc0,biscuit:#efe4d5,red brick:#d96050,hazelnut:#a97864,splice:#fefa77,grey dove:#c5bfba,rose quartz/ white: #e8959f,white/ meadow violet: #ffffff,rose quartz:#e2848a,ecru:#dfcdbc,mauve:#fa9ea6,black/ taupe:#271914,rose quartz spliced: #fa9ea6,black/ bone: #171717,olive: #968b74,pink ice: #e4dad5,aqua splash: #aed8d6,primrose: #e4c1bf,parchment: #e4d8cc,black/ black: #26262a,black/ silver: #26262a,black/ silver/ pebbled: #26262a,black/ silver/ textured: #26262a,chambray blue wash: #b3cad8,washed pink: #f0c3ce,cobalt/ black: #047adb,mist: #b0c7c1,black/ white:#171717,white/ sand:#eef2f5,melon:#fbb56d,sand/ mist:#ddd6c4,sand:#ddd6c4,white monogram:#edeef7,cobalt:#4c7bce,blue wash: #b1bfcd,cream: #e9e6e1,oyster: #bcb193,cocoa: #9b7359,mist/ teal: #789b9d,vintage black distressed: #39373c,teal: #72868f,worn brown: #7f644f,neautral multi: #cfc1a7,ice blue: #c1d1e9,washed blue: #b9c6cd,cement: #e9e6d7,acid wash: #6e666d,forest: #6c6d4d,off white: #e6e3e4,sky washed: #a5bbcd,cornflower blue: #79aacc,dove: #d7d4d7,washed black/ charcoal: #52504c,mahogany: #53423a,berry: #a3515f,charcoal check: #555052,metallic silver: #cccdc8,bubblegum: #efa8ac,flame red: #de1627,dark iris: #7c7295,charcoal marle: #59504f,gunmetal: #514e55,mushroom: #b5a38f,sandwash: #8f857b,jade: #000,soft pink: #e8d1d7,`,
          colorCodesArr = colorCodes.split(',');
      
      item.each(function() {
        if($(this).find('.swatch-view-custom-image').children().length == 0) {
          let productSwatches = '',
              productTitle = $(this).find('.prdct-info h4 a').attr('data-title'),
              productTitleArr = productTitle.split(' - '),
              productId = $(this).data('product-id');
          
          $.each(data.products, function(index, product) {
            let productOtherTitle = product.title,
                productOtherTitleArr = productOtherTitle.split(' - '),
                colorCode = '',
                imageUrl = '',
                selectedColor = '';
            if(productTitle == productOtherTitle) {
              selectedColor = 'checked';
            }
            
            if(productTitleArr.length > 2) {
              if(productTitleArr[0] == productOtherTitleArr[0] && productTitleArr[1] == productOtherTitleArr[1]) {
                for (images in bgImagesArr) {
                  let image = bgImagesArr[images].split(': ');
                  if(image[0] == productOtherTitleArr[productOtherTitleArr.length - 1].toLowerCase()) {
                    imageUrl = image[1];
                  }
                }
                for (colors in colorCodesArr) {
                  let color = colorCodesArr[colors].split(':');
                  if(color[0] == productOtherTitleArr[productOtherTitleArr.length - 1].toLowerCase()) {
                    colorCode = color[1];
                  }
                }
                productSwatches += `<div class="swatch-color-wrap">
                                      <input
                                        type="radio"
                                        name="col_${productId}"
                                        id="col_${productId}-${index+1}"
                                        class="col_${productId}"
                                        value="${productOtherTitleArr[productOtherTitleArr.length - 1]}"
                                        ${selectedColor}
                                      >
                                      <label 
                                        for="col_${productId}-${index+1}"
                                        data-product-handle="${product.handle}"
                                        data-product-id="${product.id}"
                                        title="${productOtherTitleArr[productOtherTitleArr.length - 1]}" 
                                        class="swatch-color" 
                                        style="background:${colorCode} url(${imageUrl});"
                                      ></label>
                                    </div>`;
              }
            } else {
              if(productTitleArr[0] == productOtherTitleArr[0]) {
                for (images in bgImagesArr) {
                  let image = bgImagesArr[images].split(': ');
                  if(image[0] == productOtherTitleArr[productOtherTitleArr.length - 1].toLowerCase()) {
                    imageUrl = image[1];
                  }
                }
                for (colors in colorCodesArr) {
                  let color = colorCodesArr[colors].split(':');
                  if(color[0] == productOtherTitleArr[productOtherTitleArr.length - 1].toLowerCase()) {
                    colorCode = color[1];
                  }
                }
                productSwatches += `<div class="swatch-color-wrap">
                                      <input
                                        type="radio"
                                        name="col_${productId}"
                                        id="col_${productId}-${index+1}"
                                        class="col_${productId}"
                                        value="${productOtherTitleArr[productOtherTitleArr.length - 1]}"
                                        ${selectedColor}
                                      >
                                      <label 
                                        for="col_${productId}-${index+1}"
                                        data-product-handle="${product.handle}"
                                        data-product-id="${product.id}"
                                        title="${productOtherTitleArr[productOtherTitleArr.length - 1]}" 
                                        class="swatch-color" 
                                        style="background:${colorCode} url(${imageUrl});"
                                      ></label>
                                    </div>`;
              }
            }
          });
          $(this).find('.swatch-view-custom-image').html(productSwatches);
        }
      });
      return data;
    });
  }
  // Color swatches ends
  // Collection Template Ends

  // Product Template
  // Image zoom
  if (screen.width > 900) {
    $(".template-product .productImages .img_producto_container")
      .on("click", function (e) {
        $(this).toggleClass('zoomed-in');
        if ($(this).hasClass('zoomed-in')) {
          $(this)
            .children(".img_producto")
            .css({
              transform: "scale(" + $(this).attr("data-scale") + ")"
            });
        } else {
          $(this)
            .children(".img_producto")
            .css({
              transform: "scale(1)"
            });
        }
      })
      .on("mouseout", function () {
        $(this).removeClass('zoomed-in');
        $(this)
          .children(".img_producto")
          .css({
            transform: "scale(1)"
          });
      })
      .on("mousemove", function (e) {
        $(this)
          .children(".img_producto")
          .css({
            "transform-origin": ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + "% " + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 + "%"
          });
      });
  } else {
    $('.product__main-photos .images').not('.slick-initialized').slick();
    
    let leftBound = 0;
    let topBound = 0;
    let touchtime = 0;
    $(".img_producto")
      .on("click", function (e) {
        if (touchtime == 0) {
          // set first click
          touchtime = new Date().getTime();
        } else {
          // compare first click to this click and see if they occurred within double click threshold
          if (((new Date().getTime()) - touchtime) < 800) {
            // double click occurred
            $(this).parent().toggleClass('zoomed-in');
  
            if ($(this).parent().hasClass('zoomed-in')) {

              $('.product__main-photos .images').slick(
                'slickSetOption', 
                {
                  swipe: false
                }
              );
              
              $(this).css({
                transform: "scale(" + $(this).parent().attr("data-scale") + ")"
              });
              setTimeout(() => {
                var _DRAGGGING_STARTED = 0;
                var _LAST_MOUSEMOVE_POSITION = {
                  x: null,
                  y: null
                };
                var _DIV_OFFSET = $('.img_producto_container').offset();
                var _CONTAINER_WIDTH = $(".img_producto_container").outerWidth();
                var _CONTAINER_HEIGHT = $(".img_producto_container").outerHeight();
                var _IMAGE_WIDTH;
                var _IMAGE_HEIGHT;
                var _IMAGE_LOADED = 0;
  
                _IMAGE_WIDTH = e.target.getBoundingClientRect().width;
                _IMAGE_HEIGHT = e.target.getBoundingClientRect().height;
                _IMAGE_LOADED = 1;
  
                $('.img_producto').on('touchstart', function (event) {
                  /* Image should be loaded before it can be dragged */
                  if (_IMAGE_LOADED == 1) {
                    _DRAGGGING_STARTED = 1;
  
                    /* Save mouse position */
                    _LAST_MOUSE_POSITION = {
                      x: event.originalEvent.touches[0].pageX - _DIV_OFFSET.left,
                      y: event.originalEvent.touches[0].pageY - _DIV_OFFSET.top
                    };
                  }
                });
  
                $('.img_producto').on('touchend', function () {
                  _DRAGGGING_STARTED = 0;
                });
  
                $('.img_producto').on('touchmove', function (event) {
                  if (leftBound == 0) {
                    leftBound = event.target.getBoundingClientRect().left;
                  }
                  if (topBound == 0) {
                    topBound = event.target.getBoundingClientRect().top;
                  }
                  if (_DRAGGGING_STARTED == 1) {
                    var current_mouse_position = {
                      x: event.originalEvent.touches[0].pageX - _DIV_OFFSET.left,
                      y: event.originalEvent.touches[0].pageY - _DIV_OFFSET.top
                    };
                    var change_x = current_mouse_position.x - _LAST_MOUSE_POSITION.x;
                    var change_y = current_mouse_position.y - _LAST_MOUSE_POSITION.y;
  
                    /* Save mouse position */
                    _LAST_MOUSE_POSITION = current_mouse_position;
  
                    var img_top = parseInt($(this).css('top'), 10);
                    var img_left = parseInt($(this).css('left'), 10);
  
                    var img_top_new = img_top + change_y;
                    var img_left_new = img_left + change_x;
  
                    /* Validate top and left do not fall outside the image, otherwise white space will be seen */
                    if (img_top_new > -topBound + 77)
                      img_top_new = -topBound + 77;
                    if (img_top_new < (_CONTAINER_HEIGHT - _IMAGE_HEIGHT - topBound + 77))
                      img_top_new = _CONTAINER_HEIGHT - _IMAGE_HEIGHT - topBound + 77;
                    if (img_left_new > -leftBound)
                      img_left_new = -leftBound;
                    if (img_left_new < (_CONTAINER_WIDTH - _IMAGE_WIDTH - leftBound))
                      img_left_new = _CONTAINER_WIDTH - _IMAGE_WIDTH - leftBound;
  
                    $(this).css({
                      top: img_top_new + 'px',
                      left: img_left_new + 'px'
                    });
                  }
                });
              }, 250);
  
            } else {

              $('.product__main-photos .images').slick(
                'slickSetOption', 
                {
                  swipe: true
                }
              );
  
              $(this).css({
                transform: "scale(1)"
              });
              $(this).css({
                top: "0"
              });
              $(this).css({
                left: "0"
              });
  
              $('.img_producto').off('touchstart');
              $('.img_producto').off('touchend');
              $('.img_producto').off('touchmove');
            }
            touchtime = 0;
          } else {
            // not a double click so set as a new first click
            touchtime = new Date().getTime();
          }
        }
      })
      .on("mouseout", function () {
        $(this).removeClass('zoomed-in');
        $(this)
          .children(".img_producto")
          .css({
            transform: "scale(1)"
          });
      })
  
  }
  $('.img_producto_container').height($('.zoom--img').height());
  
  $('.product__main-photos .images').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $(this).slick(
      'slickSetOption', {
        swipe: true
      }
    );
    $(this).find('.img_producto_container').removeClass('zoomed-in');
    $(this).find('.img_producto').css({
        transform: "scale(1)"
      })
      .css({
        top: "0"
      })
      .css({
        left: "0"
      })
      .off('touchstart')
      .off('touchend')
      .off('touchmove');
  });
  $(window).on('resize', function () {
    $('.img_producto_container').height($('.zoom--img').height());
  });
  // Image zoom ends

  // Similar products
  $(document).on('click', '.similar-products-section .select-option', function() {
    if($(this).hasClass('open')) {
      $(this).removeClass('open');
      $(this).next().removeClass('open');
    } else {
      $(this).addClass('open');
      $(this).next().addClass('open');
    }
  })
  
  $(document).on('click', '.similar-products-section label', function() {
    let parentContainer = $(this).parents('.size-add');
    let variantId = $(this).data('var');
    let sizeVal = $(this).data('value');

    parentContainer.find('.select-option').removeClass('open').html(sizeVal);
    parentContainer.find('.size-options').removeClass('open');
    parentContainer.find('button.add-to-cart').attr('data-var', variantId);
    
    if($(this).hasClass('sizeDisabled')) {
      parentContainer.find('button.add-to-cart').attr('disabled', true);
    } else {
      parentContainer.find('button.add-to-cart').removeAttr('disabled');
    }

    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  });
  
  $(document).on('click', '.similar-products-section .custom-add-to-cart button.add-to-cart', function() {
    let varId = $(this).attr('data-var');
    $(this).html('ADDING...');
    CartJS.addItem(varId);
  });

  
  $(".similar-products-section").each(function() {
    let sliderWrap = $(this).find('.collections__items.mob-only');
    let slider = sliderWrap.find('.similar-product-list');
    if(sliderWrap.hasClass('centermode-mob')) {
      mobileOnlySlider(slider, 1, 1, true, false, true, '80px', 900);
    } else {
      mobileOnlySlider(slider, 2, 1, false, true, false, null, 900);
    }
  });

  function swymCallbackFntn(swat) {
    $(document).on('change', '.size-optn-wrap input[type=radio]', function(e) {
      let variantId = $(this).val();
      let selector = $(this).parents('.collections__item').data('tab');

      $(this).parents('.size-add').find('.wishlist-btn button').attr('data-variant-id', variantId);
      window.triggerSwymVariantEvent(variantId);
      swat.initializeActionButtons(`[data-tab="${selector}"] .size-add`);
    });
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFntn);
  // Similar products ends

  // Related products
  if($('#shopify-section-related-products').length) {
    let item = $(this).find('.collections__item');
    loadSwatches(item);
  }
  // Related products ends
  // Product Template Ends

  // Search
  // Second image on search item hover
  $(document).on('mouseenter touchstart', '.predictive-search__list-item', function() {
    let hoverTrueImg = $(this).find('.hover-true-img');
    if(hoverTrueImg.length) {
      let hoverImg = $(this).find('img.hover-img');
      $(this).parents('.predictive-search-results-list').find('.hover-true-img').not(hoverTrueImg).show();
      $(this).parents('.predictive-search-results-list').find('img.hover-img').not(hoverImg).hide();
      hoverImg.show();
    }
  }).on('mouseleave', '.predictive-search__list-item', function() {
    if($(this).find('.hover-true-img').length) {
      $(this).find('img.hover-img').hide();
    }
  });
  // Second image on search item hover ends
  
  // Click
  $(document).on('click', '.header__search', function(e) {
    e.preventDefault();
    
    $('body').addClass('searchNonTransparent').css('overflow-y', 'hidden');
    $(".search-dropdown").addClass("active");
    setTimeout((function() {
      $('.off-canvas input[type="search"]').focus();
    }),100);
    $( ".bodyBlur" ).show();
  });
  $('.closeSearchBox').click(function() {
    $('body').removeClass('searchNonTransparent').css('overflow-y', 'auto');
    $(".search-dropdown").removeClass("active");
    $( ".bodyBlur" ).hide();
  });
  $('.bodyBlur').click(function() {
    if($('body').hasClass('searchNonTransparent')) {
      $('body').removeClass('searchNonTransparent').css('overflow-y', 'auto');
      $(".search-dropdown").removeClass("active");
      $( ".bodyBlur" ).hide();
    }
  });
  // Click ends

  // Color swatch click functionality
  $(document).on('click', 'label.search-swatch-color', function() {
    if(!$(this).prev().is(':checked')) {
      let productHandle = $(this).data('product-handle'),
          productTitle = $(this).parents('.predictive-search__list-item').find('.predictive-search__item-content .predictive-search__item-heading'),
          sliderWrapper = $(this).parents('.predictive-search__list-item').find('.prdct-img-slider'),
          mainImg = $(this).parents('.predictive-search__list-item').find('.predictive-search__item img:first-of-type').not('.hover-img'),
          hoverImg = $(this).parents('.predictive-search__list-item').find('.hover-img'),
          sizeWrapper = $(this).parents('.predictive-search__list-item').find('.size-list'),
          imageLinkWrap = $(this).parents('.predictive-search__list-item').find('.predictive-search__item'),
          sliderItems = '',
          sizeOptions = '<span class="size-optn-ttl">SIZE</span>',
          mainImgNew = '',
          hoverImgNew = '',
          hoverClass = '';

      if($(this).parents('.predictive-search__list-item').find('.hover-true-img').length) {
        hoverClass = 'hover-true-img'; 
      }
      
      jQuery.getJSON(window.Shopify.routes.root + 'products/' + productHandle + '.js', function(product) { 
        
        productTitle.attr('data-title', product.title);
        imageLinkWrap.attr('href', product.url);
        $.each(product.images, function(index, image) {
          sliderItems += `<img class="lazyload ${hoverClass}"
                            alt="${product.title}"
                            src="${image.replace('.jpg', '_50x.jpg').replace('.jpeg', '_50x.jpeg').replace('.png', '_50x.png')}"
                            data-src="${image.replace('.jpg', '_{width}x.jpg').replace('.jpeg', '_{width}x.jpeg').replace('.png', '_{width}x.png')}"
                            data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048, 2450, 2700, 3000, 3350, 3750, 4100]"
                            data-parent-fit="cover"
                            data-sizes="auto"
                          >`;
          if(index == 0) {
            mainImgNew += image;
          } else if (index == 1) {
            mainImgNew += image;
            hoverImgNew += image;
          }
        });

        $.each(product.variants, function(index, variant) {
          let disabledClass = '',
              disabledAttr = '',
              sizeValue = '';
          if(!variant.available) {
            disabledClass += 'sizeDisabled';
            disabledAttr += 'disabled';
          }
          $.each(product.options, function(index, option) {
            if(option.name == 'Size' || option.name == 'size') {
              $.each(option.values, function(index, value) {
                if(value == variant.option1 || value == variant.option2 || value == variant.option3) {
                    sizeValue += value;
                }
              });
            }
          });
          sizeOptions += `<div class="size-optn-wrap">
                            <input
                              type="radio"
                              name="size_${variant.id}"
                              id="size_${variant.id}-${index+1}"
                              class="size_${variant.id}"
                              ${disabledAttr}
                            >
                            <label
                              for="size_${variant.id}-${index+1}"
                              class="size-optn ${disabledClass}"
                              data-value="${sizeValue}" 
                              data-var="${variant.id}"
                            >
                              ${sizeValue}
                            </label>
                          </div>`;
        });

        if(sliderWrapper.length) {
          sliderWrapper.slick('unslick');
          sliderWrapper.html(sliderItems);
          deskMobSlider(sliderWrapper, 1 , 1, false, null, false, false, false, false, true, null);
        }

        if(mainImg.length) {
          if(typeof hoverImg.attr('data-src') !== 'undefined' && hoverImg.attr('data-src') !== false) {
            hoverImg.removeAttr('data-src');
          }
          hoverImg.attr('src', hoverImgNew).removeAttr('data-srcset').removeAttr('srcset');
          mainImg.attr('src', mainImgNew).removeAttr('data-srcset').removeAttr('srcset');
        }

        if(sizeWrapper.length) {
          sizeWrapper.html(sizeOptions);
        }
      });
    }
  });
  // Color swatch click functionality ends
  // Search ends

  //Accounts
  $('.add-new-address > button').click(function() {
    $(this).hide();
  });
  $('.add-new-address .form-btns button[data-address-toggle]').click(function() {
    $(this).parents('.add-new-address').children('button').show();
  });
  //Accounts ends
});


// Sidecart
function capitalize(str) {
  return str.replace(
    /\w\S*/g,
    function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}
rivets.formatters.noColorTitle = function(value){
  return value.substring(0, value.lastIndexOf(" - ") + 1);
}
rivets.formatters.capitalize = function(value){
  return capitalize(value);
}
// Sidecart ends

$('.crossSaleSlider').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: false,
   dots: true
 });